import { API } from "../config";
import { getCookie } from "../actions/auth";
import { requestWrapper } from "../utils/api";

export const sendMessageSuport = (data) => {
  const token = getCookie("token");

  return requestWrapper(
    fetch(`${API}/support/send`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-access-token": token,
      },
      body: JSON.stringify(data),
    })
  );
};

export const uploadFileAsana = (idTask, file) => {
  const token = getCookie("token");
  const formData = new FormData();

  if (file) {
    formData.append("file", file);
  } else {
    throw new Error("No file");
  }

  return requestWrapper(
    fetch(`${API}/support/upload/${idTask}`, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "x-access-token": token,
      },
    })
  );
};
